import { render, staticRenderFns } from "./ghost.vue?vue&type=template&id=557375ec&"
import script from "./ghost.vue?vue&type=script&lang=js&"
export * from "./ghost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557375ec')) {
      api.createRecord('557375ec', component.options)
    } else {
      api.reload('557375ec', component.options)
    }
    module.hot.accept("./ghost.vue?vue&type=template&id=557375ec&", function () {
      api.rerender('557375ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/ghost.vue"
export default component.exports